import { useSearchParams } from "react-router-dom";

const SsoInitialiseLanding = () => {
    const [searchParams] = useSearchParams();
    const isSuccessful =
        // Param for Microsoft entra success
        searchParams.get("admin_consent") === "True";

    return (
        <div>
            {isSuccessful
                ? "You have successfully enabled SSO for your school."
                : "SSO setup failed. Please try again or contact support."
            }
        </div>
    );
};

export default SsoInitialiseLanding;
